import * as v from 'valibot';
import { PersonSchema } from '@api/io/session.io';

const SessionChildEventSchema = v.object({
  startDate: v.nullish(v.string()),
  location: v.nullish(v.string()),
});

export const SessionChildSchema = v.object({
  projectId: v.number(),
  title: v.string(),
  thumbnail: v.nullish(v.string()),
  startDate: v.nullish(v.string()),
  endDate: v.nullish(v.string()),
  location: v.nullish(v.string()),
  events: v.nullish(v.array(SessionChildEventSchema)),
  seatsAvailable: v.nullish(v.number()),
  fullyBooked: v.boolean(),
  enrolled: v.boolean(),
  waitlisted: v.boolean(),
  instructors: v.array(PersonSchema),
});

export const SessionChildrenSchema = v.object({
  selectionProjectId: v.number(),
  items: v.array(SessionChildSchema),
});

export type TSessionChild = v.Output<typeof SessionChildSchema>;
export type TSessionChildEvent = v.Output<typeof SessionChildEventSchema>;
export type TSessionChildren = v.Output<typeof SessionChildrenSchema>;
